import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  panel: {
    height: '100%',
    textAlign: 'center',
  },
  successCheckmark: {
    height: Theme.px(192),
    marginBottom: Theme.px(40),
    marginTop: Theme.px(40),
    width: Theme.px(192),
  },
  successText: {
    color: Theme.white,
    opacity: 0.8,
  },
});
